'use strict';

angular.module('msCore').filter('isEmpty', [function () {
  return function (object) {
    return angular.equals({}, object);
  };
}]);